export default /*@ngInject*/ function  () {

    this.getWhiteListedRoutes = function () {
        return [
            "/",
            "/SIGNREPORT",
            "/DOWNLOADS",
            "/INBOX",
            "/SECURITYDESIGNER/DYNAMICS365FORFINANCEANDSUPPLYCHAINSIMULATIONDETAILS",
            "/ACCESSPROVISIONING/REQUESTDETAILS",
            "/ACCESSPROVISIONING/REVIEW",
            "/CHANGETRACKING/SETUP/TRACKINGTEMPLATEDETAILS",
            "/SECURITYDESIGNER/DYNAMICS365FORFINANCEANDSUPPLYCHAINTASKRECORDINGMANAGER"
        ];
    };
}